import { render, staticRenderFns } from "./confirmPod.vue?vue&type=template&id=4d8dd476&scoped=true&"
import script from "./confirmPod.vue?vue&type=script&lang=js&"
export * from "./confirmPod.vue?vue&type=script&lang=js&"
import style0 from "./confirmPod.vue?vue&type=style&index=0&id=4d8dd476&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8dd476",
  null
  
)

export default component.exports